import { formatPrice } from "../../utils/pricing";
import { TIP_PERCENTAGES, tipCents } from "./completion";
import styles from "./completeAppointment.module.css";

function TipStep({ totalCents, tip, onChange }) {
    function optionClass(selected) {
        return `${styles.tipOption} ${selected ? styles.tipSelected : ""}`;
    }

    return (
        <div className={styles.tip}>
            <p className={styles.muted}>Please hand the device to the customer</p>
            <h3 className={styles.tipTitle}>Add a tip?</h3>
            <p className={styles.muted}>Service total {formatPrice(totalCents)}</p>

            <div className={styles.tipGrid}>
                {TIP_PERCENTAGES.map((percent) => {
                    const selected = tip?.type === "percent" && tip.value === percent;
                    return (
                        <button
                            key={percent}
                            type="button"
                            aria-pressed={selected}
                            className={optionClass(selected)}
                            onClick={() => onChange({ type: "percent", value: percent })}
                        >
                            <strong>{percent}%</strong>
                            <span>{formatPrice(tipCents({ type: "percent", value: percent }, totalCents))}</span>
                        </button>
                    );
                })}
                <button
                    type="button"
                    aria-pressed={tip?.type === "custom"}
                    className={optionClass(tip?.type === "custom")}
                    onClick={() => onChange({ type: "custom", value: tip?.type === "custom" ? tip.value : "" })}
                >
                    <strong>Custom</strong>
                </button>
                <button
                    type="button"
                    aria-pressed={tip?.type === "none"}
                    className={optionClass(tip?.type === "none")}
                    onClick={() => onChange({ type: "none", value: 0 })}
                >
                    <strong>No tip</strong>
                </button>
            </div>

            {tip?.type === "custom" && (
                <label className={styles.customTip}>
                    <span>Tip amount</span>
                    <span className={styles.money}>
                        $
                        <input
                            type="number"
                            inputMode="decimal"
                            min="0"
                            step="0.01"
                            autoFocus
                            value={tip.value}
                            onChange={(event) => onChange({ type: "custom", value: event.target.value })}
                        />
                    </span>
                </label>
            )}
        </div>
    );
}

export default TipStep;
